module.exports = __webpack_public_path__ + "static/media/icon_event_in_lead.13ab7c02.svg";